import * as React from 'react';
import { Divider } from '@mui/material';
import { NotYetAvailable } from 'components/Badges';

import { Page } from '../../../../constants/pages';
import { Dropdown } from './MenuDropdown/Dropdown';
import { RegionalWrapper } from './RegionDropdown/RegionalWrapper';

interface Props {
  page: Page;
  active?: boolean;
}

export const DisabledMenuItem: React.FC<Props> = (props) => {
  const { page, active } = props;

  return (
    <Dropdown label={<h4>{page.title}</h4>} active={active}>
      <div className="max-w-[320px]">
        <NotYetAvailable className="p-2" />
        <Divider />
        <div className="p-4 space-y-2 font-medium text-gray-900">
          <h4>This feature is not yet available for New York / New Jersey.</h4>
          <RegionalWrapper targetRegionKey="USLA">
            <h4>Switch locations to Los Angeles / Long Beach to start using it!</h4>
          </RegionalWrapper>
        </div>
      </div>
    </Dropdown>
  );
};
DisabledMenuItem.displayName = 'DesktopNav.DisabledMenuItem';
